import type { WebhookResponse, Webhook } from '../types/webhooks';
import { VL_API_BASE_URL } from 'vince-core/constants/backendUrls';
import { APIClient } from 'vince-core/api/apiClient';

// TODO something strange with path here and in environment
const baseUrl = `${VL_API_BASE_URL}/webhooks`;

export async function loadWebhooks () {
    return await APIClient<WebhookResponse>(baseUrl);
}

export async function loadWebhooksByWorkflowId (workflowId: string) {
    return await APIClient<WebhookResponse>(`${baseUrl}?search=workflowId.keyword:${workflowId}`);
}

export async function getWebhookById (webhook: Partial<Webhook>) {
    return await APIClient<WebhookResponse>(`${baseUrl}/${webhook.webhookId}`);
}

export async function saveWebhook (webhookData: Partial<Webhook>) {
    return await APIClient<Webhook>(baseUrl, {
        method: 'POST', 
        body: JSON.stringify(webhookData) 
    });
}

export async function updateWebhook (webhookData: Partial<Webhook>) {
    return await APIClient<WebhookResponse>(baseUrl, { 
        method: 'PUT', 
        body: JSON.stringify(webhookData) 
    });
}

export async function deleteWebhook (webhook: Partial<Webhook>) {
    return await APIClient<WebhookResponse>(`${baseUrl}/${webhook.webhookId}`, { method: 'DELETE' });
}
